export const sliders = [
  {
    label: "Sold electricity Margin",
    key: "sold_electricity_margin",
    value: 0,
    defaultValue: 0,
  },
  {
    label: "Purchased Electricity Margin",
    key: "purchased_electricity_margin",
    value: 0,
    defaultValue: 0,
  },
  {
    label: "PRaaS AI & Digitalization Impact Over Time",
    key: "digitalization_impact",
    value: 0,
    defaultValue: 0,
  },
  {
    label: "Gas prices",
    key: "gas_prices",
    value: 0,
    defaultValue: 0,
  },
];
